import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * 合併 class 名稱，後出現的 Tailwind utility 覆蓋先前同屬性者。
 *
 * @example
 * cn('px-2 py-1', 'px-4')  // 'py-1 px-4'（px-4 會覆蓋 px-2）
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
